export const searchTypes = {
  SIMPLE_SEARCH: 'SIMPLE_SEARCH',
  ADVANCED_SEARCH: 'ADVANCED_SEARCH',
}

export const roles = ['administrador', 'jefe', 'empleado'];